/**
 * 画像のベースURL
 * @constant {string}
 */
export const IMAGE_BASE_URL = 'https://storage.googleapis.com/uchino_ai_img_dir/webroot/default'

/**
 * アイコン名の定数
 * @constant {Object}
 */
export const ICON_NAMES = {
  PASSWORD: 'ic_pass',
  FORM: 'ic_youser',
  // 他のアイコンも追加
}

/**
 * 画像名の定数
 * @constant {Object}
 */
export const IMG_NAMES = {
  HEADER: 'ai',
  BOT: 'bot2',
  BUTTON: 'ai',
  ABUTTON: 'bot1',
}

/**
 * 画像のフルURLを取得
 * @param {string} path - 画像のパス
 * @returns {string} フルURL
 */
export const getImageUrl = (img) => {
  return `${IMAGE_BASE_URL}/img/chat/${img}.webp`
}

/**
 * タイプアイコンのURLを取得
 * @param {string} typeName - タイプ名（TYPE_NAMES の値を推奨）
 * @returns {string} タイプアイコンのフルURL
 */
export const getTypeIconUrl = (typeName) => {
  return `${IMAGE_BASE_URL}/img/type_ic/${typeName}.webp`
}